"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIUserRole = void 0;
var APIUserRole;
(function (APIUserRole) {
    APIUserRole["Admin"] = "admin";
    APIUserRole["Guest"] = "guest";
    APIUserRole["Technician"] = "technician";
})(APIUserRole = exports.APIUserRole || (exports.APIUserRole = {}));
//# sourceMappingURL=Memberships.js.map